import _ from "loadsh";
import shjrConfig from "../site/shjr"
import defaultConfig from "../site/default"
let r = {
    provinces: [
        {key: "", label: "全国"},
        {key: "北京", label: "北京"},
        {key: "天津", label: "天津"},
        {key: "河北", label: "河北"},
        {key: "山西", label: "山西"},
        {key: "内蒙古", label: "内蒙古"},
        {key: "辽宁", label: "辽宁"},
        {key: "吉林", label: "吉林"},
        {key: "黑龙江", label: "黑龙江"},
        {key: "上海", label: "上海"},
        {key: "江苏", label: "江苏"},
        {key: "浙江", label: "浙江"},
        {key: "安徽", label: "安徽"},
        {key: "福建", label: "福建"},
        {key: "江西", label: "江西"},
        {key: "山东", label: "山东"},
        {key: "河南", label: "河南"},
        {key: "湖北", label: "湖北"},
        {key: "湖南", label: "湖南"},
        {key: "广东", label: "广东"},
        {key: "广西", label: "广西"},
        {key: "海南", label: "海南"},
        {key: "重庆", label: "重庆"},
        {key: "四川", label: "四川"},
        {key: "贵州", label: "贵州"},
        {key: "云南", label: "云南"},
        {key: "西藏", label: "西藏"},
        {key: "陕西", label: "陕西"},
        {key: "甘肃", label: "甘肃"},
        {key: "青海", label: "青海"},
        {key: "宁夏", label: "宁夏"},
        {key: "新疆", label: "新疆"},
    ],
    sorts: [
        {key: '正序', label: '正序'},
        {key: '倒序', label: '倒序'}
    ],
    timeList: [
        {key: '今日', label: '今日',},
        {key: '近7日', label: '近7日'},
        {key: '本月', label: '本月'},
        {key: '最近三月', label: '最近三月'},
    ],
    contentRisks: [
        // {key: '', label: '全部内容风险'},
        // {key: "人事风险", label: "人事风险"},
        // {key: "组织与管理风险", label: "组织与管理风险"},
        // {key: "产品风险", label: "产品风险"},
        // {key: "企业文化风险", label: "企业文化风险"},
        // {key: "营销风险", label: "营销风险"},
        // {key: "财务风险", label: "财务风险"},
        // {key: "顾客风险", label: "顾客风险"},
        // {key: "政治环境风险", label: "政治环境风险"},
        // {key: "经济环境风险", label: "经济环境风险"},
        // {key: "社会环境风险", label: "社会环境风险"},
        // {key: "技术环境风险", label: "技术环境风险"},
        // {key: "法律环境风险", label: "法律环境风险"},
    ],
    yinbaojianRisks: [
        // {key: '', label: '全部监管标签'},
        // {key: '保险风险', label: '保险风险'},
        // {key: "信息科技风险", label: "信息科技风险"},
        // {key: "战略风险", label: "战略风险"},
        // {key: "国别风险", label: "国别风险"},
        // {key: "流动性风险", label: "流动性风险"},
        // {key: "操作风险", label: "操作风险"},
        // {key: "市场风险", label: "市场风险"},
        // {key: "信用风险", label: "信用风险"},
        // {key: "利率风险", label: "利率风险"},
        // {key: "其他风险", label: "其他风险"}
    ],

    effects: [
        {key: '', label: '全部影响力等级'},
        {key: 'A', label: '影响力A'},
        {key: 'B', label: '影响力B'},
        {key: 'C', label: '影响力C'},
        {key: 'D', label: '影响力D'},
        {key: 'E', label: '影响力E'},
    ],
    risks: [
        {key: '', label: '全部风险等级'},
        {key: 1, label: 'I级风险'},
        {key: 2, label: 'II级风险'},
        {key: 3, label: 'III级风险'},
        {key: 4, label: 'IV级风险'},
        {key: 5, label: 'V级风险'}
    ],
    tendencies: [
        {key: '', label: '全部倾向',},
        {key: '负面', label: '敏感',},
        {key: '正面', label: '正面',},
        {key: '中性', label: '中性',}
    ],
    subIndustries: [
        {key: "银行业", label: "银行业"},
        {key: "保险业", label: "保险业"},
        {key: "证券业", label: "证券业"},
        {key: "基金业", label: "基金业"},
        {key: "信托业", label: "信托业"},
        // {key: "期货业", label: "期货业"},
        // {key: "资管业", label: "资管业"},
        // {key: "融资租赁业", label: "融资租赁业"},
        // {key: "消费金融业", label: "消费金融业"},
        // {key: "贷款公司业", label: "贷款公司业"},
        {key: "其他", label: "其他金融业"}
    ],
    industryLabelMap: {
        '全行业': '金融业',
        '银行业': '银行',
        '保险业': '保险',
        '证券业': '证券',
        '基金业': '基金',
        '信托业': '信托',
        // '期货业': '期货',
        // '资管业': '资管',
        // '融资租赁业': '融资租赁',
        // '消费金融业': '消费金融',
        // '贷款公司业': '贷款公司',
        '其他金融业': '其他'
    },
    defaultIndustries:[
        {key: "银行业", label: "银行业"},
        {key: "保险业", label: "保险业"},
    ],

    companyNavList: [
        '舆情总览',
        '风险分析',
        '媒体口碑',
        // '网络口碑',
    ],
    reportsNavList: [
        '自助报告',
        // '行业报告',
    ],
    reportNavList: [
        '舆情概述',
        '风险概述',
        '媒体传播',
        '焦点报道'
    ],
    channelStatsButtons: [
        {name: '企业', tag: 'company'},
        {name: '高管', tag: 'manager'},
    ],
    reportPeriod: ['day', 'week', 'month', 'year', 'halfYear'],
    reportPeriodMap: {'day': '日', 'week': '周', 'month': '月', 'year': '年'},
    reportYesPeriodMap: {'day': '昨日', 'week': '上周', 'month': '上月', 'year': '去年'},
    compareTypes: [
        {value: 'industry', label: '行业', disabled: false},
        {value: 'company', label: '企业', disabled: false},
    ],
    romaMap: {1: "I", 2: "II", 3: "III", 4: "IV", 5: "V"},
    reportTypeOption: [
        {value: 'industry', label: '行业', disabled: false},
        {value: 'company', label: '企业', disabled: false},
    ],
    reportDateOption: [
        {value: 'day', label: '日报', disabled: false},
        {value: 'month', label: '月报', disabled: false},
    ],
    defalutRiskMap: {
        "yinbaoRisk":[
            /*{category: "战略风险", count: 0, per: 0},
            {category: "操作风险", count: 0, per: 0},
            {category: "市场风险", count: 0, per: 0},
            {category: "流动性风险", count: 0, per: 0},
            {category: "信用风险", count: 0, per: 0},
            {category: "法律风险", count: 0, per: 0},
            {category: "国别风险", count: 0, per: 0},
            {category: "信息科技风险", count: 0, per: 0},
            {category: "保险风险", count: 0, per: 0},
            {category: "其他风险", count: 0, per: 0},*/
        ],
        "contentRisk":[
            {category: "人事风险", count: 0, per: 0},
            {category: "产品风险", count: 0, per: 0},
            {category: "财务风险", count: 0, per: 0},
            {category: "违法违规", count: 0, per: 0},
            {category: "关联交易风险", count: 0, per: 0},
        ]
    },
    token: 'f0c071d0ffc547a3bf0c81a8496183bd',
    source: 'admin',
    companyHealthLabelPptMap :{
        "best": "positive",
        "good":"alert",
        "normal":"negative"
    },
    exportOptions: [
        // {value: 'local', label: '导出到本地', disabled: true},
        {value: 'email', label: '导出到邮箱', disabled: false},

    ],
    exportTypes: [
        {value: 'png', label: '图片', disabled: false, pages: ["report", "compare", "rankList"]},
        {value: 'PPT', label: 'PPT', disabled: false, pages: ["report", "compare"]},
        {value: 'excel', label: 'excel', disabled: false, pages: ["rankList", "eventList"]}
    ],
    defaultPageExportType: {
        report: "png",
        compare: "png",
        rankList: "png",
        eventList: "excel"
    },
    contentRiskDesc: "注：透过舆情视角，结合监管分类，进一步挖掘企业存在的具体风险点。以上仅展示部分主要内容风险点。",
    yinbaoRiskDesc: `注：依据中国银行保险监督管理委员会最新发布的《<a class="font_b co_000" href="https://www.cbirc.gov.cn/cn/view/pages/govermentDetail.html?docId=967210&itemId=861&generaltype=1" target="_blank">银行保险机构声誉风险管理办法（试行）</a>》中对银行保险机构应对处置的十大类风险进行归类。`,
    defaultReportId: "636df1c3fec39c2ac33af41a"
}


export default _.extend(r, {
    industries: [{key: '金融业', label: '全行业'}].concat(r.subIndustries),
    defaultIndustryNames: _.map(r.defaultIndustries, "label"),
    subIndustryNames : _.map(r.subIndustries, sub=>{
        return {
            key: sub.key.replace("业", ""),
            label: sub.label.replace("业", "")
        }
    }),
    siteConfig: location.hostname === "shifd.focuxy.com" ? shjrConfig : defaultConfig
})
